import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@seu-services';
import { format, formatDistance } from 'date-fns';
import { SEU_DATE_FORMAT } from '../types/date.type';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'seuDate',
  standalone: true,
})
export class SeuDatePipe implements PipeTransform {
  public readonly languageService = inject(LanguageService);
  public readonly translateService = inject(TranslateService);

  public transform(
    date: Date | undefined | null,
    formatKey: keyof typeof SEU_DATE_FORMAT = 'DATE'
  ): string | undefined {
    if (date === undefined || date === null) {
      return '-';
    }

    switch (formatKey) {
      case 'ELAPSED':
        return formatDistance(date, new Date(), {
          addSuffix: true,
        });
      default:
        return format(date, SEU_DATE_FORMAT[formatKey]);
    }
  }
}
